import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/remote-work-quiz/RemoteWorkQuizContent.tsx");
